import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {getOrCreateOfferListingAmplitudeItemListId} from "../../offer/list/helpers/offer_listing_amplitude_item_list_id";
import {Country} from "../../region/types/Country";
import {ViewType} from "../../view_type/ViewType";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {timeOptions} from "../constants/time_options";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {RegionSearchTabsType} from "../types/RegionSearchTabsType";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {SearchMethod} from "../types/SearchMethod";
import {SearchTab} from "../types/SearchTab";
import {TransportLabels} from "../types/TransportLabels";
import {TravelTimeTransport} from "../types/TravelTimeTransport";
import {getAmplitudeSearchQuery} from "../utils/get_amplitude_search_query";
import {
    clearPendingGlobalSearch,
    firePendingGlobalSearch,
    getLastGlobalSearchMethod,
    setPendingGlobalSearch,
    trackAmplitudeGlobalSearch
} from "./track_amplitude_global_search";
import {trackAmplitudeGlobalSearchAdvanced} from "./track_amplitude_global_search_advanced";

interface TrackParams {
    searchQuery: string;
    searchMethod: SearchMethod;
    offersCount?: number;
}

export const useTrackAmplitudeGlobalSearch = () => {
    const tabData = useSelector((state: IRPStore) => state.search.currentTabData);
    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const formValues = useSelector((state: IRPStore) => state.search.formValues) as SearchFormValuesType;
    const locationSearchTab = useSelector((state: IRPStore) => state.search.searchForm.locationSearchTab);
    const travelTimeData = useSelector((state: IRPStore) => state.search.travelTime.data);
    const viewType = useSelector((state: IRPStore) => state.viewType);

    const getSearchContext = (): string => {
        if (viewType.current === ViewType.PROPERTY_CONFIGURATOR) return "Konfigurator";
        if (tabData.currentTab === SearchTab.Holiday) return "Wakacyjne";
        if (tabData.country === Country.SPAIN) return "Hiszpania";
        return "Polska";
    };

    // no customFilters → use current form values (manual_input, popular_search_click)
    // customFilters provided → use stored search filters (recent_search_click)
    const buildAmplitudeSearchQuery = (search: ISearchInputValue | undefined, customFilters?: Partial<ISearchFiltersFormValues>): string =>
        getAmplitudeSearchQuery(search, customFilters ?? formValues);

    const buildTravelTimeSearchQuery = (): string => {
        const address = (formValues.search as ISearchInputValue | undefined)?.label ?? "";
        const transportLabel = travelTimeData.transport_type === TravelTimeTransport.PUBLIC_TRANSPORT ? TransportLabels.PUBLIC_TRANSPORT : TransportLabels.CAR;
        const timeLabel = timeOptions.find((option) => option.value === travelTimeData.travel_time)?.label ?? "";
        return `${address}|${transportLabel}|${timeLabel}`;
    };

    const fireAmplitudeSearch = (params: TrackParams): void => {
        const payload = {
            ...params,
            searchContext: getSearchContext(),
            itemListId: getOrCreateOfferListingAmplitudeItemListId(latestQuery)
        };
        trackAmplitudeGlobalSearch(payload);
    };

    const trackAmplitudeSearch = (params: TrackParams): void => fireAmplitudeSearch(params);

    // Stage a global_search event to be fired when the search is actually submitted.
    // Captures searchQuery and offersCount at click time so the data is correct even if
    // the component re-renders before the user hits the submit button.
    const setPendingAmplitudeSearch = (searchQuery: string, searchMethod: SearchMethod, offersCount?: number): void => {
        setPendingGlobalSearch(() => fireAmplitudeSearch({searchQuery, searchMethod, offersCount}));
    };

    const trackAmplitudeSearchAdvanced = (params?: {distance?: number; searchOverride?: ISearchInputValue}): void => {
        const searchContext = getAdvancedSearchContext(locationSearchTab);
        const isTravelTime = locationSearchTab === RegionSearchTabsType.TRAVEL_TIME;
        const searchValue = params?.searchOverride ?? (formValues.search as ISearchInputValue | undefined);
        const searchQuery = isTravelTime ? buildTravelTimeSearchQuery() : buildAmplitudeSearchQuery(searchValue);
        const distance = params?.distance ?? (formValues.distance as number | null | undefined);
        const range = distance ? `${distance} km` : undefined;
        const itemListId = getOrCreateOfferListingAmplitudeItemListId(latestQuery);
        const searchMethod = getLastGlobalSearchMethod();
        const payload = {searchQuery, searchMethod, searchContext, range, itemListId};
        trackAmplitudeGlobalSearchAdvanced(payload);
    };

    return {
        trackAmplitudeSearch,
        buildAmplitudeSearchQuery,
        currentSearch: formValues?.search as ISearchInputValue | undefined,
        trackAmplitudeSearchAdvanced,
        setPendingAmplitudeSearch,
        // Fires the staged event and returns true; returns false (no-op) when nothing was staged.
        firePendingAmplitudeSearch: firePendingGlobalSearch,
        // Discards the staged event — call when the user starts typing to avoid stale method.
        clearPendingAmplitudeSearch: clearPendingGlobalSearch
    };
};

const getAdvancedSearchContext = (tab: RegionSearchTabsType | null): string => {
    if (tab === RegionSearchTabsType.TRAVEL_TIME) return "Czas dojazdu";
    if (tab === RegionSearchTabsType.DISTRICTS) return "Dzielnice";
    return "Lokalizacja";
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {getOrCreateOfferListingAmplitudeItemListId} from "../../offer/list/helpers/offer_listing_amplitude_item_list_id";
import {Country} from "../../region/types/Country";
import {ViewType} from "../../view_type/ViewType";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {timeOptions} from "../constants/time_options";
import {ISearchFiltersFormValues} from "../types/ISearchFiltersFormValues";
import {RegionSearchTabsType} from "../types/RegionSearchTabsType";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {SearchMethod} from "../types/SearchMethod";
import {SearchTab} from "../types/SearchTab";
import {TransportLabels} from "../types/TransportLabels";
import {TravelTimeTransport} from "../types/TravelTimeTransport";
import {getAmplitudeSearchQuery} from "../utils/get_amplitude_search_query";
import {
    clearPendingGlobalSearch,
    firePendingGlobalSearch,
    getLastGlobalSearchMethod,
    setPendingGlobalSearch,
    trackAmplitudeGlobalSearch
} from "./track_amplitude_global_search";
import {trackAmplitudeGlobalSearchAdvanced} from "./track_amplitude_global_search_advanced";

interface TrackParams {
    searchQuery: string;
    searchMethod: SearchMethod;
    offersCount?: number;
}

export const useTrackAmplitudeGlobalSearch = () => {
    const tabData = useSelector((state: IRPStore) => state.search.currentTabData);
    const latestQuery = useSelector((state: IRPStore) => state.offerList.list.latestQuery);
    const formValues = useSelector((state: IRPStore) => state.search.formValues) as SearchFormValuesType;
    const locationSearchTab = useSelector((state: IRPStore) => state.search.searchForm.locationSearchTab);
    const travelTimeData = useSelector((state: IRPStore) => state.search.travelTime.data);
    const viewType = useSelector((state: IRPStore) => state.viewType);

    const getSearchContext = (): string => {
        if (viewType.current === ViewType.PROPERTY_CONFIGURATOR) return "Konfigurator";
        if (tabData.currentTab === SearchTab.Holiday) return "Wakacyjne";
        if (tabData.country === Country.SPAIN) return "Hiszpania";
        return "Polska";
    };

    // no customFilters → use current form values (manual_input, popular_search_click)
    // customFilters provided → use stored search filters (recent_search_click)
    const buildAmplitudeSearchQuery = (search: ISearchInputValue | undefined, customFilters?: Partial<ISearchFiltersFormValues>): string =>
        getAmplitudeSearchQuery(search, customFilters ?? formValues);

    const buildTravelTimeSearchQuery = (): string => {
        const address = (formValues.search as ISearchInputValue | undefined)?.label ?? "";
        const transportLabel = travelTimeData.transport_type === TravelTimeTransport.PUBLIC_TRANSPORT ? TransportLabels.PUBLIC_TRANSPORT : TransportLabels.CAR;
        const timeLabel = timeOptions.find((option) => option.value === travelTimeData.travel_time)?.label ?? "";
        return `${address}|${transportLabel}|${timeLabel}`;
    };

    const fireAmplitudeSearch = (params: TrackParams): void => {
        const payload = {
            ...params,
            searchContext: getSearchContext(),
            itemListId: getOrCreateOfferListingAmplitudeItemListId(latestQuery)
        };
        trackAmplitudeGlobalSearch(payload);
    };

    const trackAmplitudeSearch = (params: TrackParams): void => fireAmplitudeSearch(params);

    // Stage a global_search event to be fired when the search is actually submitted.
    // Captures searchQuery and offersCount at click time so the data is correct even if
    // the component re-renders before the user hits the submit button.
    const setPendingAmplitudeSearch = (searchQuery: string, searchMethod: SearchMethod, offersCount?: number): void => {
        setPendingGlobalSearch(() => fireAmplitudeSearch({searchQuery, searchMethod, offersCount}));
    };

    const trackAmplitudeSearchAdvanced = (params?: {distance?: number; searchOverride?: ISearchInputValue}): void => {
        const searchContext = getAdvancedSearchContext(locationSearchTab);
        const isTravelTime = locationSearchTab === RegionSearchTabsType.TRAVEL_TIME;
        const searchValue = params?.searchOverride ?? (formValues.search as ISearchInputValue | undefined);
        const searchQuery = isTravelTime ? buildTravelTimeSearchQuery() : buildAmplitudeSearchQuery(searchValue);
        const distance = params?.distance ?? (formValues.distance as number | null | undefined);
        const range = distance ? `${distance} km` : undefined;
        const itemListId = getOrCreateOfferListingAmplitudeItemListId(latestQuery);
        const searchMethod = getLastGlobalSearchMethod();
        const payload = {searchQuery, searchMethod, searchContext, range, itemListId};
        trackAmplitudeGlobalSearchAdvanced(payload);
    };

    return {
        trackAmplitudeSearch,
        buildAmplitudeSearchQuery,
        currentSearch: formValues?.search as ISearchInputValue | undefined,
        trackAmplitudeSearchAdvanced,
        setPendingAmplitudeSearch,
        // Fires the staged event and returns true; returns false (no-op) when nothing was staged.
        firePendingAmplitudeSearch: firePendingGlobalSearch,
        // Discards the staged event — call when the user starts typing to avoid stale method.
        clearPendingAmplitudeSearch: clearPendingGlobalSearch
    };
};

const getAdvancedSearchContext = (tab: RegionSearchTabsType | null): string => {
    if (tab === RegionSearchTabsType.TRAVEL_TIME) return "Czas dojazdu";
    if (tab === RegionSearchTabsType.DISTRICTS) return "Dzielnice";
    return "Lokalizacja";
};
